/**
 * Модель для хранения id части элементов
 */
export class PartItemArray {
  $partId: string; // Id части (системная переменная - удалить из модели при отправке)
  $checkedFlk: boolean; // Результат проверки по ФЛК части (системная переменная - удалить из модели при отправке)
}
